<template>
  <div class="group-content">
    <NavHeaderBar :showSearch="false" :navBarTitle="$t('form.storeGroup')">
      <div class="right-header" @click="toUrl('/store/groupManagement')">
        <!-- 管理分组 -->
        {{ $t('button.manage') }}
      </div>
    </NavHeaderBar>
    <!-- 按分组名称筛选 -->
    <van-search v-model="groupSearchVal" :placeholder="$t('tips.filterByGroupName')" @input="getSearchSuggFn" />
    <div class="group-section">
      <van-collapse v-model="groupActiveNames">
        <van-collapse-item v-for="(collapseItem) in groupList" :key="collapseItem.id" :title="`${collapseItem.labelName}(${collapseItem.relevancyList.length})`" name="1">
          <!-- + 添加门店到该分组 -->
          <div class="add-group" @click="handleGroup(collapseItem)">+ {{ $t('button.addStoreToGroup') }}</div>
          <div v-for="(subItem) in collapseItem.relevancyList" :key="subItem.id" class="store-group" @click.stop="toUrl('detail', subItem)">
            <div style="flex: 1;">
              <div class="store-info">
                <span v-if="!['', null].includes(subItem.customerTag)" class="store-status van-ellipsis" :class="subItem.customerTag | formatTagClass">{{ subItem.customerTag | formatTag }}</span>
                <span class="store-name van-ellipsis">{{ subItem.customerName }}</span>
              </div>
              <div class="address-info">
                <img class="address-img" src="@/assets/images/ditu.png" alt="" />
                <span class="address-name van-ellipsis">{{ subItem.address }}</span>
              </div>
            </div>
            <img class="del-img" src="@/assets/images/event_del.png" alt="" @click.stop="handleDel(collapseItem, subItem)">
          </div>
        </van-collapse-item>
      </van-collapse>
      <van-empty v-if="groupList.length <= 0" :description="$t('tips.noData')" />
    </div>
    <XuStoreSelect v-model="showStorePicker" @confirm="onConfirmStore" :currentGroup="currentGroup" :multiple="true" pageType="storeGroup" />
  </div>
</template>

<script>
import { arsLabelListApi, arsLabelDeleteRelevancyApi } from '@/api/storePage'
import { Toast, Dialog } from 'vant'
import i18n from '@/i18n'
export default {
  components: {
    XuStoreSelect: () => import('@/components/XuStoreSelect')
  },
  filters: {
    formatTag (value) {
      return value === 0 ? i18n.t('shared.filter.toBeVerified') : value === 1 ? i18n.t('shared.filter.sVIPCore') : value === 2 ? i18n.t('shared.filter.vIPCore') : value === 3 ? i18n.t('shared.filter.potential') : ''
    },
    formatTagClass (value) {
      return `tag${value}`
    }
  },
  data () {
    return {
      groupSearchVal: '',
      groupActiveNames: ['1'],
      groupList: [],
      showStorePicker: false,
      currentGroup: {
        relevancyList: []
      },
      paramsUrl: {}
    }
  },
  activated () {
    this.paramsUrl = this.$route.query
    this.getLabelData()
  },
  methods: {
    handleGroup (params) {
      this.currentGroup = params
      this.showStorePicker = true
    },
    getLabelData () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      const data = {
        labelName: this.groupSearchVal,
        isAllot: this.paramsUrl.pageType === 'storeExpansion' ? 0 : 1
      }
      arsLabelListApi(data).then(res => {
        Toast.clear()
        this.groupList = res.data
      })
    },
    handleDel (params, currentItem) {
      Dialog.confirm({
        message: this.$t('tips.messageTwo'), // 将该门店从当前分组移除（不会直接删除门店）
        confirmButtonText: this.$t('button.remove'),
        cancelButtonText: this.$t('button.cancel'),
        confirmButtonColor: '#d9001b'
      })
        .then(() => {
          Toast.loading({
            message: this.$t('shared.loading'),
            forbidClick: true,
            duration: 0
          })
          const data = {
            labelId: params.id,
            relevancyIdList: [currentItem.id]
          }
          arsLabelDeleteRelevancyApi(data).then(res => {
            Toast.clear()
            this.getLabelData()
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    onConfirmStore (item) {
      this.getLabelData()
    },
    toUrl (url, params) {
      if (url === 'detail') {
        let pageUrl = ''
        if (params.isAllot === 0) {
          pageUrl = `/storeExpansion/storeMappingDetail?customerId=${params.id}`
        } else {
          pageUrl = `/storeMaintain/storeMappingDetail?customerId=${params.id}`
        }
        this.$router.push(pageUrl)
      } else {
        this.$router.push(url)
      }
    },
    getSearchSuggFn () {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        clearTimeout(this.timer)
        this.timer = null
        this.getLabelData()
      }, 500)
    }
  }
}
</script>

<style lang="less" scoped>
.group-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  .right-header {
    width: 74px;
    color: #307bff;
  }
  /deep/.van-search {
    .van-search__content {
      border-radius: 20px;
      .van-field__control {
        font-size: 12px;
      }
    }
  }
  .group-section {
    flex: 1;
    .add-group {
      color: #307bff;
      padding: 8px 10px;
      font-size: 12px;
      border-bottom: 1px solid #f2f2f2;
    }
    .store-group {
      display: flex;
      align-items: center;
      padding: 8px 10px;
      border-bottom: 1px solid #f2f2f2;
      .del-img {
        width: 17px;
        height: 17px;
      }
    }
    .store-info {
      display: flex;
      align-items: center;
      margin-bottom: 4px;

      .store-status {
        max-width: 79px;
        padding: 3px 5px;
        text-align: center;
        font-size: 10px;
        border: 1px solid #ee541b;
        color: #ee541b;
        background-color: #eccfc4;
        margin-right: 6px;
      }
      .tag0 {
        border: 1px solid #0db00b;
        color: #0db00b;
        background-color: #abdaaa;
      }
      .tag2 {
        border: 1px solid #dc851f;
        color: #dc851f;
        background-color: #f0e2d1;
      }
      .tag3 {
        border: 1px solid #7f7f7f;
        color: #7f7f7f;
        background-color: #dcdcdc;
      }

      .store-name {
        max-width: 243px;
        font-size: 14px;
        color: #333;
        font-weight: 500;
      }
    }

    .address-info {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #999;

      .address-img {
        width: 12px;
        height: 12px;
        margin-right: 4px;
      }

      .address-name {
        max-width: 310px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  /deep/.van-collapse {
    .van-collapse-item {
      background-color: #fff;
      .van-collapse-item__title {
        background-color: #e8effc;
        font-weight: bold;
        padding: 8px 10px;
        margin-bottom: 2px;
        .van-cell__title {
          font-weight: bold;
          > span {
            font-size: 14px;
          }
        }
      }
      .van-collapse-item__content {
        padding: 0;
      }
    }
  }
}
</style>
